import { FC } from 'react'
import cx from 'classnames'

import { LinkProps } from '../Link'

import * as SC from './styled'

export type RoundedTagProps = LinkProps & {
  className?: string
}

const RoundedTag: FC<RoundedTagProps> = ({ className, ...linkProps }) => {
  return <SC.Container className={cx('RoundedTag', className)} {...linkProps} />
}

export default RoundedTag
